export const EditLocalStoragePagesData = (pathname, params, value) => {
    try {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}

        const newPageData = {
            ...pagesData,
            [pathname]: {...pagesData[pathname], [params]: value}
        }
        localStorage.setItem("pagesData", JSON.stringify(newPageData))
    } catch (err) {
        console.warn("pagesData: failed to save", pathname, params, err)
    }
}
